import AppSearchPageMixin from "@/protected/mixins/AppSearchPageMixin";
import SearchParametersEditor from "./CustomerSearchParametersEditor";
import service from "./CustomerService";

export default {
  mixins: [AppSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "companyName",
            label: this.$t("customer.fields.companyName"),
            styleClass: "col-6",
            sortBy: "companyName",
            onClick: ({ row }) => {
              this.$router.push({ name: "Customer", params: { id: row.id } });
            }
          },
          {
            key: "fiscalCode",
            label: this.$t("customer.fields.fiscalCode"),
            styleClass: "col-3",
            sortBy: "fiscalCode"
          },
          {
            key: "vatNumber",
            label: this.$t("customer.fields.vatNumber"),
            styleClass: "col-3",
            sortBy: "vatNumber"
          }
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          {
            key: 'lastModifiedOffline',
            label: this.$t('common.lastModifiedOffline')
          }
          */
        ];
      }
    }
  },

  data() {
    return {
      sort: {
        sort: "companyName",
        order: "ASC"
      }
    };
  },

  methods: {
    getService() {
      return service;
    },

    onAdd() {
      this.$router.push({ name: "Customer", params: { id: "new" } });
    }
  }
};
